module.exports = __webpack_public_path__ + "img/update-info.ccc986a9.png";